<template>
    <svg width="14" height="22" viewBox="0 0 14 22" xmlns="http://www.w3.org/2000/svg">
        <path d="m12 20-9-9.033L12 2" stroke="#033D89" stroke-width="3" fill="none" fill-rule="evenodd" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconReturn',
};
</script>
